import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../../../../collection'
import type * as ecModels from '../../../../models'
import * as plugin from '../../../plugin'
import type { Plugin } from '../plugin'

const PLUGIN_ID = plugin.Plugin.Id.Standard.Attribute

/**
 * Eagerly requests attributes when things are initialized or the context
 * changes
 */
export const eagerlyRequestAttributes = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    collection: Collection<TTypeParams>,
  ) =>
    collection.plugins.apiExecutionPlugin.canExecute('getAttributes')
      ? rxjs
          .merge(
            collection.feature.actions.changeContext.observe(),
            collection.ready$,
          )
          .pipe(
            // Prevents emissions until the entity collection and this plugin
            // are ready
            rxjs.skipUntil(collection.ready$),
            // Mainly prevents duplicate executions of the effect on
            // initialization
            rxjs.debounceTime(50),
            // Sends the request to getAttributes
            rxjs.map(action =>
              feature.actions.getAttributes.request
                .from(
                  action ??
                    // This only occurs when not based on a context change
                    'eagerlyRequestAttributes on collection.ready$ (effect)',
                )
                .create(),
            ),
          )
      : undefined,
)
